<span [matMenuTriggerFor]="tagsFilterMenu" style="cursor: pointer">{{ 'tagFilterMenu.tags' | translate }}</span>
<mat-menu #tagsFilterMenu="matMenu" class="menu-no-items" (close)="menuClosed()">
  <h4>{{ 'tagFilterMenu.filterTags' | translate }}</h4>
  <form class="form-full-width" [formGroup]="form">
    <mat-form-field (click)="$event.stopPropagation()">
      <mat-label>{{ 'tagFilterMenu.labels.contains' | translate }}</mat-label>
      <mat-chip-grid #containsTagList formControlName="contains">
        <mat-chip-row *ngFor="let tag of form.controls.contains.value; index as chipIndex"
          (removed)="containsTagDelete(chipIndex)"
          [style]="{backgroundColor: getTagColor(tag)}">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input #typeInputElementContains test-id="contains-tag-input" formControlName="containsTagInput"
          [matAutocomplete]="autoCompleteContains"
          [matChipInputFor]="containsTagList" [matChipInputAddOnBlur]="true">
        <mat-autocomplete test-id="contains-tag-autocomplete" #autoCompleteContains="matAutocomplete"
          (optionSelected)="autoCompleteSelected('contains', $event)" panelWidth="auto">
          <mat-option *ngFor="let suggestion of suggestedContainsTags" [value]="suggestion">
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>
      </mat-chip-grid>
    </mat-form-field>
    <mat-form-field (click)="$event.stopPropagation()">
      <mat-label>{{ 'tagFilterMenu.labels.notContains' | translate }}</mat-label>
      <mat-chip-grid #excludesTagList formControlName="excludes">
        <mat-chip-row *ngFor="let tag of form.controls.excludes.value; index as chipIndex" [removable]="true"
          (removed)="excludeTagDelete(chipIndex)" [style]="{backgroundColor: getTagColor(tag)}">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input #typeInputElementExcludes test-id="excludes-tag-input" formControlName="excludesTagInput"
          [matAutocomplete]="autoCompleteExcludes"
          [matChipInputFor]="excludesTagList" [matChipInputAddOnBlur]="true">
        <mat-autocomplete test-id="add-tag-autocomplete" #autoCompleteExcludes="matAutocomplete"
          (optionSelected)="autoCompleteSelected('excludes', $event)" panelWidth="auto">
          <mat-option *ngFor="let suggestion of suggestedExcludesTags" [value]="suggestion">
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>
      </mat-chip-grid>
    </mat-form-field>
  </form>
  <button mat-stroked-button color="primary" class="full-width" (click)="reset()">{{ 'tagFilterMenu.buttons.reset' | translate }}</button>
</mat-menu>
